import React from 'react'

import { IconProps } from '.'

const Boy: React.FC<IconProps> = ({ size = 40, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 40 40"
      {...rest}
    >
      <circle cx="20" cy="20" r="20" fill="#2D87F3" />
      <path
        fill="#fff"
        d="M20.002 30.973c-2.616 0-4.945-.607-6.734-1.755-1.82-1.166-3.058-2.884-3.604-4.992-.045 0-.09.003-.136.003-.758 0-1.486-.3-2.023-.834a2.843 2.843 0 010-4.029 2.868 2.868 0 012.194-.83c.577-2.321 1.83-4.42 3.567-5.952C15.16 10.918 17.552 10 20.002 10s4.84.918 6.733 2.587c1.737 1.53 2.99 3.628 3.567 5.952a2.868 2.868 0 012.194.83 2.843 2.843 0 010 4.028 2.868 2.868 0 01-2.16.831c-.546 2.106-1.782 3.826-3.602 4.992-1.79 1.146-4.118 1.753-6.732 1.753z"
      />
      <path
        fill="#2D87F3"
        d="M17.95 13.19h-.014a.525.525 0 00-.524.509c0 .015-.059 1.466-2.006 1.927a.525.525 0 00-.389.63.523.523 0 00.633.386c2.18-.516 2.793-2.134 2.812-2.917a.519.519 0 00-.313-.491.527.527 0 00-.2-.044zM20.591 12.874a.524.524 0 00-.326.663c.004.014.455 1.396-1.212 2.5a.521.521 0 00.19.936.526.526 0 00.39-.066c1.866-1.236 1.878-2.966 1.625-3.708a.521.521 0 00-.464-.352.529.529 0 00-.203.027zM23.292 13.4a.525.525 0 00-.735.749c.008.007.787.783.35 2.119a.523.523 0 00.898.508.523.523 0 00.098-.183c.641-1.946-.56-3.142-.611-3.192zM15.977 21.818a1.365 1.365 0 000-1.936 1.38 1.38 0 00-1.945 0 1.365 1.365 0 000 1.936 1.38 1.38 0 001.945 0zM25.445 22.172a1.368 1.368 0 10-.682-2.652 1.369 1.369 0 10.682 2.652zM22.837 22.755a.532.532 0 00-.66.338c-.005.012-.414 1.222-2.124 1.222-1.71 0-2.12-1.21-2.124-1.222a.523.523 0 00-.998.316c.026.08.656 1.947 3.123 1.947s3.097-1.867 3.122-1.947a.52.52 0 00-.339-.654z"
      />
    </svg>
  )
}

export default Boy
